module.exports = __webpack_public_path__ + "static/media/ins1.12cbc5a2.jpg";